import React from 'react';
import { ClipboardListIcon } from 'lucide-react';
export function Navbar() {
  return <nav className="sticky top-0 z-50 w-full bg-primary-dark border-b border-primary-light/30 shadow-lg" data-id="element-84">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="flex justify-between items-center h-20" data-id="element-86">
          <div className="flex items-center gap-3" data-id="element-87">
            <div className="bg-accent/20 p-2 rounded-lg" data-id="element-88">
              <ClipboardListIcon className="h-6 w-6 text-accent" data-id="element-89" />
            </div>
            <span className="text-white font-bold text-xl tracking-tight" data-id="element-90">
              Administración <span className="text-accent" data-id="element-91">360</span>
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8" data-id="element-92">
            <a href="#bonos" className="text-gray-300 hover:text-white transition-colors font-medium" data-id="element-93">
              Bonos
            </a>
            <a href="#testimonios" className="text-gray-300 hover:text-white transition-colors font-medium" data-id="element-94">
              Testimonios
            </a>
            <a href="#comprar" className="bg-cta hover:bg-cta-hover text-white px-6 py-2.5 rounded-full font-bold transition-all transform hover:scale-105 shadow-[0_0_15px_rgba(220,38,38,0.4)]" data-id="element-95">
              COMPRAR
            </a>
          </div>
        </div>
      </div>
    </nav>;
}